import React from "react"
import { Link, graphql } from "gatsby"
import RecentImageBlob from "../components/recentimageblob"
import RecentBlogsBlob from "../components/recentblogsblob"
import Layout from "gatsby-theme-wirehead-bulma/src/layout"
import TwoCol from "gatsby-theme-wirehead-bulma/src/twocol"
import SEO from "gatsby-theme-wirehead-bulma/src/seo"
import { MDXRenderer } from "gatsby-plugin-mdx"
import SchemaBlogPosting from "../components/schema-blogposting"
import wrappedImageList from "../components/wrappedimagelist"

export default function PageTemplate({ data, location, pageContext }) {
  const { mdx } = data // data.markdownRemark holds your post data
  const { body } = mdx

  const imgs = wrappedImageList(mdx.srcImages);

  return (
    <Layout posted={pageContext.date} updated={pageContext.updated}>
      <SEO
        title={pageContext.title}
        pathname={location.pathname}
        description={pageContext.excerpt} />
      <SchemaBlogPosting
        pathname={location.pathname}
        title={pageContext.title}
        datePublished={pageContext.date}
        breadcrumbs={pageContext.breadcrumbs}
      />
    <section className="section">
    <TwoCol
        left={
          <div className="content">
            <h1 className="title">{pageContext.title}</h1>
            <MDXRenderer imgs={imgs} >{body}</MDXRenderer>
          </div>
        }
        right={
          <div>
          <aside className="sidebar" dangerouslySetInnerHTML={{__html:mdx.fields.sidebar}} />
          <div className="sideblock">
          <h3>Recent Blog Posts:</h3>
          <RecentBlogsBlob />
          </div>
          <div className="sideblock is-clearfix">
          <h3>Recent Images:</h3>
          <RecentImageBlob />
          <br />
          </div>
          </div>
        }
      />
    </section>
    <section className="section">
    </section>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($id: String) {
    mdx(id: { eq: $id }) {
      body
      id
      fields {
        sidebar
      }
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        type
        description
        sidebar
      }
      srcImages {
        id
        key
        maxSize
        size
        srcSet
        srcPath
        width
        height
        sqSrcSet
        srcSet
      }
      excerpt(pruneLength: 300)
    }
  }
`
